import {getLookup, getSalesforceInfo} from '../../apis/sthree.consultant.api';
//import _ from 'lodash';

export default {
    state: {
        sfMode: true,
        token: '',
        environment: '',
        lookup: {},
        error: ''
    },
    mutations: {
        sfMode(state, sfMode) {
            state.sfMode = sfMode;
        },
        token(state, token) {
            state.token = token;
        },
        lookup(state, {type, values, parentId}){
            const x = Object.assign({}, state.lookup);
            if (parentId){
                x[type] = {};
                x[type][parentId] = values.options;
                
            } else {
                x[type] = values.options;
            }
            state.lookup = x;
        },
        setEnvironment(state, env) {
            state.environment = env;
        },
        setAppError(state, error){
            state.error = error;
        }
    },
    actions: {
        setSfMode({commit}, sfMode) {
            commit('sfMode', sfMode);
        },
        setToken({commit}, token) {
            commit('token', token);
        },
        async lookup({commit, state}, {type, parentId, userId}){
            return getLookup(type, parentId, userId)
                .then((values) => {
                    commit('lookup', {type, values, parentId});
                });
        },
        async getSalesforceInfo({commit}){
            return getSalesforceInfo()
                .then((value) => {
                    commit('setEnvironment', value.instanceUrl);
                });
        }
    }
}